/* eslint-disable */
/**
 * WARNING: THIS FILE IS AUTO-GENERATED, DO NOT EDIT IT DIRECTLY!
 */

import * as Types from './types'

import { GraphQLClient } from 'graphql-request';
import { RequestInit } from 'graphql-request/dist/types.dom';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import fetcher from '../../fetchers/fetcher';

export type GetGeosearchResultsQueryVariables = Types.Exact<{
  autocompleteInput: Types.AddressAutocompleteInput;
  placesInput: Types.PlaceAutocompleteInput;
}>;


export type GetGeosearchResultsQuery = { __typename?: 'Query', addressAutocomplete?: Array<{ __typename?: 'AddressSuggestion', mainText: string, secondaryText?: string | null, placeId: string } | null> | null, placeAutocomplete: { __typename?: 'PlaceAutoCompleteSuggestion', regions: Array<{ __typename?: 'PlaceAutoCompleteSuggestionInfo', slug: string, nameLong: string }>, cities: Array<{ __typename?: 'PlaceAutoCompleteSuggestionInfo', slug: string, nameLong: string }>, metroAreas: Array<{ __typename?: 'PlaceAutoCompleteSuggestionInfo', slug: string, nameLong: string }>, neighbourhoods: Array<{ __typename?: 'PlaceAutoCompleteSuggestionInfo', slug: string, nameLong: string }>, streets: Array<{ __typename?: 'PlaceAutoCompleteSuggestionInfo', slug: string, nameLong: string }> } };


export const GetGeosearchResultsDocument = /*#__PURE__*/ `
    query GetGeosearchResults($autocompleteInput: AddressAutocompleteInput!, $placesInput: PlaceAutocompleteInput!) {
  addressAutocomplete(input: $autocompleteInput) {
    mainText
    secondaryText
    placeId
  }
  placeAutocomplete(input: $placesInput) {
    regions {
      slug
      nameLong
    }
    cities {
      slug
      nameLong
    }
    metroAreas {
      slug
      nameLong
    }
    neighbourhoods {
      slug
      nameLong
    }
    streets {
      slug
      nameLong
    }
  }
}
    `;
export const useGetGeosearchResultsQuery = <
      TData = GetGeosearchResultsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetGeosearchResultsQueryVariables,
      options?: UseQueryOptions<GetGeosearchResultsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetGeosearchResultsQuery, TError, TData>(
      ['GetGeosearchResults', variables],
      fetcher<GetGeosearchResultsQuery, GetGeosearchResultsQueryVariables>(client, GetGeosearchResultsDocument, variables, headers),
      options
    );